import { httpClient } from './http-client.service';
import type {
  OrchestrationProduct,
  GatewayConfig,
  OrchestrationFeatureFlags,
} from '../types/orchestration-config';

export const orchestrationConfigAPI = {
  getProducts: async (): Promise<{ products: OrchestrationProduct[] }> => {
    const response = await httpClient.get<any>('orchestration/products');
    return response.data.data;
  },

  getGatewayConfig: async (exchangeApplicationId: string): Promise<GatewayConfig> => {
    const response = await httpClient.get<any>(
      `orchestration/gateway-config?exchange_application_id=${encodeURIComponent(exchangeApplicationId)}`
    );
    return response.data.data;
  },

  getFeatureFlags: async (): Promise<OrchestrationFeatureFlags> => {
    const response = await httpClient.get<any>('orchestration/feature-flags');
    return response.data.data;
  },

  updateWebhooks: async (exchangeApplicationId: string, callbackWebhooks: any[]): Promise<any> => {
    const response = await httpClient.post<any>('orchestration/update-webhooks', {
      exchange_application_id: exchangeApplicationId,
      callback_webhooks: callbackWebhooks,
    });
    return response.data.data;
  },

  updateWorkflow: async (exchangeApplicationId: string, workflowConfiguration: any): Promise<any> => {
    const response = await httpClient.post<any>('orchestration/update-workflow', {
      exchange_application_id: exchangeApplicationId,
      workflow_configuration: workflowConfiguration,
    });
    return response.data.data;
  },

  getAllActiveProducts: async (): Promise<any> => {
    const response = await httpClient.get<any>('orchestration/all-products');
    return response.data.data;
  },

  enableOrchestrationForProduct: async (productCode: string, exchangeApplicationId: string, transactionIdResponse: boolean = true, instanceName?: string, headerDescription?: string, confirm?: boolean): Promise<any> => {
    const body: any = {
      product_code: productCode,
      exchange_application_id: exchangeApplicationId,
      transaction_id_response: transactionIdResponse,
    };
    if (instanceName) body.instance_name = instanceName;
    if (headerDescription) body.header_description = headerDescription;
    if (confirm) body.confirm = true;
    const response = await httpClient.post<any>('orchestration/enable-product', body);
    return response.data.data;
  },

  updateFullConfig: async (exchangeApplicationId: string, config: any): Promise<any> => {
    const response = await httpClient.post<any>('orchestration/update-config', {
      exchange_application_id: exchangeApplicationId,
      config,
    });
    return response.data.data;
  },
};
